import type { ID } from '@savvy/utils/id';
import { LocalStorage } from '@savvy/deprecated-shared/utils/local-storage';
import { LOGGED_IN_AS_ADVISOR_ADMIN_ID } from '@savvy/deprecated-shared/utils/local-storage/key-consts';

export function loggedInAsAdminID() {
  return LocalStorage.getItemSync_WebOnly(LOGGED_IN_AS_ADVISOR_ADMIN_ID);
}

export function removeLoggedInAsAdminID() {
  LocalStorage.removeItemSync_WebOnly(LOGGED_IN_AS_ADVISOR_ADMIN_ID);
}

export function addLoggedInAsAdminID(adminID: ID) {
  LocalStorage.setItemSync_WebOnly(LOGGED_IN_AS_ADVISOR_ADMIN_ID, adminID.toString());
}
